<app-feature-details-grid>
  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.SOLARLOG.INVERTER.TITLE' | translate }}"
  >
    <app-feature-list-item
      *ngIf="inverterModel$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.INVERTER.MODEL' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="inverterManufacturer$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.INVERTER.MANUFACTURER' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="inverterEtn$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.INVERTER.SERIAL_NUMBER' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <!-- photovoltaic.installedPeakPower -->
    <app-feature-list-item
      *ngIf="inverterInstalledPeakPower$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.INVERTER.POWER_PEAK' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>

<app-feature-details-grid>
  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.TITLE' | translate }}"
  >
    <app-feature-list-item
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.NAME' | translate"
      [value]="gatewayName$ | async"
      [attr.data-feature]="'gatewayName'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="gatewayEtn$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.SERIAL_NUMBER' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="gatewayFirmware$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.FIRMWARE' | translate"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>
